import { DashboardSortOrderOption } from '../../../model/dashboard-sort-order.model';

export const BUCKET_FILTER_PLACEHOLDER = 'Filter by insurance or assessing company';
export const BUCKET_FILTER_NO_RESULTS_MESSAGE =
  'No results matching your filter. You can clear your filter by pressing on the X icon.';

export const BUCKET_SORT_OPTIONS: DashboardSortOrderOption[] = [
  {
    name: 'LAST_RECEIVED_DATETIME_ASC',
    value: 'lastReceivedDateTime',
    direction: 'ASC',
    label: 'Date received (oldest to newest)'
  },
  {
    name: 'LAST_RECEIVED_DATETIME_DESC',
    value: 'lastReceivedDateTime',
    direction: 'DESC',
    label: 'Date received (newest to oldest)'
  },
  {
    name: 'INSPECTION_DATE_ASC',
    value: 'inspectionDate',
    direction: 'ASC',
    label: 'Inspection date (earliest to latest)'
  }
];
